import React from "react"
import Layout from "../components/layout"
import SEO from '../components/seo'
import styled from "@emotion/styled"
import TicketButton from "../components/ticketButton"
import BouncingBall from "../images/ball.png"

const TourPageContainer = styled.div`
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-top: 8rem;
    margin-bottom: 5rem;

    @media (max-width: 425px) {
        margin-top: 8rem;
        margin-bottom: 8rem;
    }
`

const TourPageTitle = styled.h1`
    text-align: center;

    & span {
        color: #d6756c;
        -webkit-text-stroke: 0;
    }

    @media (max-width: 768px) {
        font-size: 2rem;
    }

    @media (max-width: 425px) {
        font-size: 1.75rem;
    }

    @media (max-width: 320px) {
        font-size: 1.5rem;
    }
`

const TourBallImg = styled.img`
    width: 50px;
    height: 50px;
    margin-bottom: -0.5rem;

    @media (max-width: 425px) {
        width: 40px;
        height: 40px;
    }

    @media (max-width: 320px) {
       width: 30px;
       height: 30px; 
    }
`

/* Tour Infomation Styles */

const TourInfoLink = styled.a`
    width: 70%;
    border-bottom: 1px solid #100504;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-diection: row;
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    -webkit-box-pack: space-between;
    -ms-flex-pack: space-between;
    justify-content: space-between;
    text-decoration: none;
    color: #100504;

    @media (max-width: 1400px) {
        width: 80%;
    }

    @media (max-width: 1250px) {
        width: 90%;
    }
`

const InfoContainer = styled.div`
    width: 25%;
    text-align: center;
    margin-bottom: 1rem;
    margin-top: 1rem;

    @media (max-width: 425px) {
        margin-bottom: 0.5rem;
    }
`

const TourDate = styled.h3`

    @media (max-width: 768px) {
        font-size: 1.2rem;
    }

    @media (max-width: 425px) {
        font-size: 0.9rem;
    }

    @media (max-width: 320px) {
        font-size: 0.8rem;
    }
`

const TourPlace = styled.h3`

    @media (max-width: 768px) {
        font-size: 1.2rem;
    }

    @media (max-width: 425px) {
        font-size: 0.9rem;
    }

    @media (max-width: 320px) {
        font-size: 0.8rem;
    }
`

const TourLocation = styled.h3`

    @media (max-width: 768px) {
        font-size: 1.2rem;
    }

    @media (max-width: 425px) {
        font-size: 0.9rem;
    }

    @media (max-width: 320px) {
        font-size: 0.8rem;
    }
`

/* Tour Info Object */
const TourInfo = props => (
    <TourInfoLink href={props.link} target="_blank" rel="noopener noreferrer">
        <InfoContainer>
            <TourDate>{props.date}</TourDate>
        </InfoContainer>
        <InfoContainer>
            <TourPlace>{props.place}</TourPlace>
        </InfoContainer>
        <InfoContainer>
            <TourLocation>{props.location}</TourLocation>
        </InfoContainer>
        <InfoContainer>
            <TicketButton />
        </InfoContainer>
    </TourInfoLink>
)

function TourPage() {
    return (
        <div>
            <SEO title="Tour" />
            <Layout>
                <TourPageContainer>
                    <TourPageTitle><span>Me &amp;</span> Bobby McGee<TourBallImg src={BouncingBall} alt='bouncing ball'/> 2020 Book Tour</TourPageTitle>
                    <TourInfo
                        link="/"
                        date="05/30/2020"
                        place="Rosemary and Thyme"
                        location="Novigrad, RE"
                    />
                    <TourInfo
                        link="/"
                        date="05/31/2020"
                        place="Oxenfurt Academy"
                        location="Oxenfurt, RE"
                    />
                    <TourInfo
                        link="/"
                        date="06/06/2020"
                        place="Crow's Perch"
                        location="Velen, TE"
                    />
                    <TourInfo
                        link="/"
                        date="06/07/2020"
                        place="Crookback Bog"
                        location="Velen, TE"
                    />
                    <TourInfo
                        link="/"
                        date="07/11/2020"
                        place="Kaer Trolde"
                        location="Ard Skellig, SK"
                    />
                    <TourInfo
                        link="/"
                        date="07/18/2020"
                        place="Temple of Freya"
                        location="Hindarsfjall, SK"
                    />
                    <TourInfo
                        link="/"
                        date="08/08/2020"
                        place="Beauclair Palace"
                        location="Beauclair, TO"
                    />
                    <TourInfo
                        link="/"
                        date="08/09/2020"
                        place="Corvo Bianco"
                        location="Sansretour Valley, TO"
                    />
                </TourPageContainer>
            </Layout>
        </div>
    )
}

export default TourPage